import { useQuery } from "@tanstack/react-query";

import { getAvailableSlots } from "../../api/queries";

export const useAvailableSlots = (siteId: string, amount:number) => useQuery(["availableSlots", siteId, amount], () => getAvailableSlots(siteId, amount));
 